// 토큰 키 통일 부팅 마이그레이션: 구 번들에서 의뢰기업(request)으로 로그인한 세션은 access 토큰이
// 소문자 'accesstoken' 에만 있다. 새 번들은 카멜 'accessToken' 을 읽으므로 부팅 시 1회 복사해
// 재로그인/불필요한 401 없이 세션을 이어가게 한다.
// ⛔ store 모듈 평가(= state.accessToken 초기화)보다 먼저 실행돼야 store state 도 올바르게 채워지므로,
//    main.js 에서 store import 보다 앞서 import 한다. (잔여 소문자 쓰기 제거(CONTRACT) 후 이 모듈도 제거 예정.)
try {
    const _bad = (v) => !v || v === 'undefined' || v === 'null';
    const _camel = localStorage.getItem('accessToken');
    const _lower = localStorage.getItem('accesstoken');
    if (_bad(_camel) && !_bad(_lower)) {
        localStorage.setItem('accessToken', _lower);
    } else if (_camel === 'undefined' || _camel === 'null') {
        // garbage 문자열이 저장돼 있고 복구할 소문자도 없으면 청소한다(guard 가 truthy 로 오인 /
        // Bearer 'undefined' 전송 방지). 정상 토큰이나 null 은 건드리지 않는다.
        localStorage.removeItem('accessToken');
    }
} catch (_e) { /* localStorage 접근 불가 환경 무시 */ }
